import * as React from 'react';
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";
import { ApplicationState } from '../store';
import * as AuthStore from "../store/Auth";
import { fetchData, postQuery } from '../utils';
import * as moment from 'moment';
import { Redirect } from "react-router-dom";
import { Table, Input, Select, message, Row, Col, Button, DatePicker } from 'antd';
import { OrderedListOutlined, RedoOutlined, CloseCircleOutlined, DownloadOutlined } from '@ant-design/icons';
const { Option } = Select;
const { RangePicker } = DatePicker;

type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

class Uploads extends React.PureComponent<AuthProps>
{
    
    async componentDidMount()
    {
        const { pagination } = this.state;

        this.getItems({
            results: pagination.pageSize,
            searchText: this.state.searchText,
            page: pagination.current,
            sortField: pagination.sorter.field,
            sortOrder: pagination.sorter.order
        });
    }

    public state =
        {
            buttonText: 'Add',
            data: [],
            pagination:
            {
                current: 1,
                total: 0,
                pageSize: 10,
                sorter: {
                    field: "name",
                    order: "asc"
                }
            },
            errors: [],
            errPagination:
            {
                current: 1,
                total: 0,
                pageSize: 10,
                sorter: {
                    field: "name",
                    order: "asc"
                }
            },
            loading: false,
            confirmLoading: false,
            title: 'New Site',
            upload: { id: '', facilityName: '', fileName: '', stateCode: '', batch: '', dateUploaded: '', statusStr: '', dateUploadedStr: '', totalFileCount: 0, failedFiles: 0, status: '', path: '', errors: 0 },
            searchText: "",
            visible: false,
            hideUpload: false,
            from: '',
            to: '',
            showDetails: false,
            fileUrl: ''
        };
      
    exit()
    {
        this.setState({ showDetails: false});
    }

    handleTableChange(pagination: any, filters: any, sorter: any)
    {
        const pager = this.state.pagination;
        pager.current = pagination.current;

        console.log(sorter);

        this.setState({
            pagination: pager,
            sortField: sorter.field,
            sortOrder: sorter.order
        });

        this.getItems({
            results: pager.pageSize,
            searchText: this.state.searchText,
            page: pager.current,
            sortField: sorter.field,
            sortOrder: sorter.order
        });
    }

    errorTableChange(pagination: any, filters: any, sorter: any)
    {
        const pager = this.state.errPagination;
        pager.current = pagination.current;

        this.state.errPagination = pager;
        
        this.getErrors({
            results: pager.pageSize,
            page: pager.current
        });
    }
    
    async getItems(params: any)
    {
        this.setState({ loading: true });
        var searchText = params.searchText;
        var results = params.results;
        var page = params.page;
        let el = this;

        var query = `/api/Site/getUploads?itemsPerPage=${results}&pageNumber=${page}&term=${searchText}&sorter=${params.sortField}&sortOrder=${params.sortOrder}`;
       
        let res = await fetchData(query);

        const { pagination } = el.state;
        pagination.total = res.totalItems;
        el.setState({
            data: res.uploads,
            pagination,
            loading: false
        });


        if (searchText && searchText.trim().length > 0)
        {
            const reg = new RegExp(searchText, 'gi');
            this.setState({
                filtered: !!searchText,
                data: this.state.data.map((record: any) =>
                {
                    const match = record.batch.toString().match(reg) || record.fileName.toString().match(reg);

                    if (!match) {
                        return null;
                    }
                    return {
                        ...record,
                        fileName: (<span> {record.fileName.split(reg).map((text: any, i: any) => (i > 0 ? [<span key={record.id} className="highlight">{match[0]}</span>, text] : text
                        ))}
                        </span>
                        )
                    };
                }).filter(record => !!record)
            });
        }
    }

    handleChange(value: string)
    {
        const { pagination } = this.state;
        pagination.pageSize = parseInt(value);

        this.setState({
            pagination: pagination
        });

        this.getItems({
            results: pagination.pageSize,
            searchText: this.state.searchText,
            page: pagination.current
        });
    }
    
    onInputChange(e: { target: { value: string; }; })
    {
        let searchTerm = e.target.value.trim();
        this.setState({ searchText: searchTerm });
        const { pagination } = this.state;
        this.getItems({
            results: pagination.pageSize,
            searchText: searchTerm,
            page: pagination.current
        });
    }
    
    onSearch() {
        const { pagination } = this.state;
        this.getItems({
            results: pagination.pageSize,
            searchText: this.state.searchText,
            page: pagination.current
        });
    }
    
    async processdata()
    {
        this.setState({ loading: true });
        let res = await postQuery('/api/NMRSProcessor/processAllUploads');
        this.setState({ loading: false });
        if (res.code < 1)
        {
            message.error(res.message);
        }
        if (res.code > 0)
        {
            message.success(res.message);

            const { pagination } = this.state;

            this.getItems({
                results: pagination.pageSize,
                searchText: this.state.searchText,
                page: pagination.current,
                sortField: pagination.sorter.field,
                sortOrder: pagination.sorter.order
            });
        }
    }
    
    getUploadErrors(data: any)
    {
        this.state.upload = data;

        var errp =
        {
            current: 1,
            total: 0,
            pageSize: 20,
            sorter: {
                field: "name",
                order: "asc"
            }
        };

        this.setState({ errPagination: errp});        
        this.getErrors({ results: errp.pageSize, page: errp.current });
    }
    
    async getErrors(params: any)
    {
        var results = params.results;
        var page = params.page;
        let el = this;
        this.setState({ loading: true });
        var query = `/api/Site/getUploadErrors?upload=${el.state.upload.id}&itemsPerPage=${results}&pageNumber=${page}`;
        let res = await fetchData(query);
        this.setState({ loading: false });

        if (!res.uploadErrors)
        {
            message.error(`No Errors were found for this Upload`);
            return;
        }

        if (res.uploadErrors.length < 1)
        {
            message.error(`No Errors were found for this Upload`);
            return;
        }

        const { errPagination } = el.state;

        errPagination.total = res.totalItems;

        el.setState({
            errors: res.uploadErrors,
            errPagination,
            loading: false,
            showDetails: true
        });
    }
    
    async queue(data: any)
    {
        let el = this;
        el.setState({ upload: data, loading: true });
        let res = await postQuery('/api/Site/queueDataUpload?id=' + data.id, {});
        el.setState({ loading: false });
        if (res < 1)
        {
            message.error(res.message);
        }
        if (res.code > 0)
        {
            message.success('Upload re-queued for processing');
            const { pagination } = el.state;
            el.getItems({
                results: pagination.pageSize,
                searchText: el.state.searchText,
                page: pagination.current,
                sortField: pagination.sorter.field,
                sortOrder: pagination.sorter.order
            });
        }
    }
    
    async getxml(data: any)
    {
        let el = this;
        el.setState({ loading: true });
        var request = new XMLHttpRequest();
        request.open("GET", '/api/Stats/getxml?file=' + el.state.upload.path + '&xmlName=' + data.fileName);
        request.responseType = "blob";
        request.onload = function ()
        {
            el.setState({ loading: false });
            var msie = window.navigator.userAgent.indexOf("MSIE");
            if (msie > 0)
            {
                window.navigator.msSaveBlob(this.response, data.fileName);
            }
            else
            {
                var url = window.URL.createObjectURL(this.response);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.href = url;
                a.download = this.response.name || data.fileName;
                a.click();
                a.remove();
            }
        }
        request.send();       
    }
    
    async exportUpload()
    {
        let el = this;

        if (el.state.from.length < 1)
        {
            message.error("Please select a Date Range");
            return;
        }
        if (el.state.to.length < 1)
        {
            message.error("Please select a Date range");
            return;
        }

        el.setState({ loading: true });
        let res = await fetchData('/api/Site/exportUpload?from=' + this.state.from + '&to=' + this.state.to );
        el.setState({ loading: false });
        if (res.code < 1)
        {
            message.error(res.message);
        }
        else
        {
            let fUrl = '/api/Stats/getFile?baseF=' + res.asset + '&filename=' + res.fileName;
            el.setState({ loading: false, fileUrl: fUrl });    
        }
    }

    dateRangeChange(a: any[], dateString: any)
    {
        let from = '';
        let to = '';
        if (dateString && dateString[0]) {
            from = dateString[0];
        }
        else {
            from = '';
        }

        if (dateString && dateString[1])
        {
            to = dateString[1];
        }
        else
        {
            from = '';
        }
        this.setState({ from: from, to: to });    
    }

    public render()
    {
        const { appUser } = this.props;
        //if (!appUser.isAuthenticated || appUser.role === "2")
        //{
        //    return <Redirect to="/welcome" />;
        //}

        const { searchText, showDetails, upload, fileUrl, from, to } = this.state;
        //defaultSortOrder: 'descend',
        //sorter: true,
        const columns =
            [
                {
                    title: 'State',
                    dataIndex: 'stateName',
                    key: 'stateName',
                    //sorter: true,
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Facility',
                    dataIndex: 'facilityName',
                    key: 'facilityName',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Batch Number',
                    dataIndex: 'batch',
                    key: 'batch',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'File Name',
                    dataIndex: 'fileName',
                    key: 'fileName',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Date Uploaded',
                    dataIndex: 'dateUploadedStr',
                    key: 'dateUploadedStr',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Uploaded By',
                    dataIndex: 'uploadedByName',
                    key: 'uploadedByName',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Total Files',
                    dataIndex: 'totalFileCount',
                    key: 'totalFileCount',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{(value === null || value === undefined) ? 0 : String(value).replace(/(.)(?=(\d{3})+$)/g, '$1,')}</span>
                },
                {
                    title: 'Status',
                    dataIndex: 'statusStr',
                    key: 'statusStr',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                }
                //,
                //{
                //    title: 'Last Data Upload',
                //    dataIndex: 'lastDateUploadedStr',
                //    key: 'lastDateUploadedStr',
                //    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                //}
                
            ];   

        if (appUser && appUser.isAuthenticated && appUser.role === "1")
        {
            columns.push({
                title: 'Process',
                dataIndex: '', key: 'x',
                render: (text: any, record: any) =>
                    <a className="tb-span" key={record.id} title="Queue for Processing" onClick={() => this.queue(record)} style={{ cursor: 'pointer', fontWeight: 500 }}>
                        <RedoOutlined />
                    </a>
            });
        }        
                
        return (
            <div className="site-top">
                <Helmet>
                    <title>CDR - Data Uploads</title>
                </Helmet>
                {/*<img className="waiter2" src={waiter} alt="" style={{ width: '54px', height: '54px', display: loading ? 'block' : 'none' }} />*/}
                <Row style={{ marginTop: '2px' }}>
                    <Col span={24} style={{ marginTop: '15px', marginBottom: '15px' }}>
                        <h4 style={{ fontWeight: 'bold', fontSize: '18px' }}>Data Uploads</h4>
                    </Col>
                </Row>
                <div className="custom-filter-dropdown up" style={{ display: showDetails? 'none' : 'block'}}>                    
                    <Row gutter={2}>
                        <Col xs={24} sm={24} md={8} lg={8}>
                            <Select defaultValue="10" id="pageSize" className="top-10-margin" onChange={(v) => this.handleChange(v)} style={{ width: '98%', float: 'left' }}>
                                <Option value="10">10</Option>
                                <Option value="50">50</Option>
                                <Option value="100">100</Option>
                                <Option value="150">150</Option>
                                <Option value="200">200</Option>
                                <Option value="300">300</Option>
                                <Option value="500">500</Option>
                            </Select>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={8}>
                            <Input className="ant-input-lg-2 top-10-margin" placeholder="Enter File Name/Batch Number to search..." value={searchText} onChange={(e) => this.onInputChange(e)} onPressEnter={this.onSearch} />
                        </Col>
                        <Col xs={24} sm={24} md={6} lg={6}>                        
                        </Col>
                    </Row>
                    <br />
                    <Row gutter={2}>
                        <Col xs={24} sm={24} md={8} lg={8}>
                           <RangePicker className="circl-radius"
                                //@ts-ignore
                                value={[from.length > 0 ? moment(from, "YYYY-MM-DD") : null, to.length > 0 ? moment(to, "YYYY-MM-DD") : null]}
                                allowClear={true} onChange={(a: any, b: any) => this.dateRangeChange(a, b)} disabled={this.state.loading}
                            />
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={8}>
                            <Button type="default" style={{ float: 'left', marginLeft: '8px', height: '40px'}} className="dl-excel" onClick={() => this.exportUpload()} shape="round" icon={<DownloadOutlined />}>
                                Export to Excel
                            </Button>
                        </Col>
                    </Row>
                    <br />
                    <Row gutter={2}>
                        <Col span={24} style={{ overflow: "scroll" }}>
                            <Table columns={columns} rowKey={record => record.id} dataSource={this.state.data} pagination={this.state.pagination} loading={this.state.loading} onChange={(a: any, b: any, c: any) => this.handleTableChange(a, b, c)} bordered />
                        </Col>
                        <div style={{ display: 'none' }}>
                            <iframe src={fileUrl} />
                        </div>
                    </Row>
                </div>                   
            </div>
        );
    }
};

export default connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(Uploads as any);
